var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1.902771 6.836792 L 1.902771 26.794128 C 1.902771 27.977356 2.556976 28.921082 3.702423 28.921082 L 24.151001 28.921082 C 24.973328 28.921082 25.786499 28.107666 25.786499 27.285339 L 25.786499 16.324585 C 25.786499 14.211182 22.187775 14.127197 22.187775 16.488098 L 22.187775 25.158508 L 5.665253 25.158508 L 5.665253 8.636047 L 14.499237 8.636047 C 16.647491 8.636047 16.647491 5.037109 14.499237 5.037109 L 3.702423 5.037109 C 2.746399 5.037109 1.902771 5.880981 1.902771 6.836792"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#334368",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 17.60733 3.237427 C 17.60733 5.932251 20.074921 5.364197 22.678406 5.364197 C 21.785645 6.69751 17.673401 10.122131 16.367767 11.812927 C 15.409546 13.053955 14.333282 13.975403 13.229614 15.055542 C 12.595123 15.675903 12.117401 16.162048 12.355377 17.153076 C 12.46817 17.624634 12.637909 17.904419 12.988892 18.162048 C 14.649261 19.385925 15.994873 17.675354 17.09201 16.300293 L 25.132294 8.30896 C 25.132294 9.286865 25.014496 10.421204 25.215851 11.333069 C 25.751678 13.761108 28.894775 13.098511 28.894775 11.089966 L 28.894775 3.401611 C 28.894775 2.445557 28.051147 1.601746 27.095123 1.601746 L 19.570129 1.601746 C 18.514435 1.601746 17.60733 2.214355 17.60733 3.237427"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.2411939dd4ee5d6c11ede8708d9b2efd.svg";
export { ForwardRef as ReactComponent };